<template>
  <v-dialog v-model="displayConfirmationModal" max-width="684px" persistent>
    <v-card>
      <v-card-title>
        <div class="headline">
          <span class="text-capitalize" v-if="isDisabling">
            {{$t('amazon_transparency_disable')}}
          </span>
          <span class="text-capitalize" v-else>
            {{$t('amazon_transparency_enable')}}
          </span>
          <span class="text-lowercase">{{ $t('amazon_transparency_auto_upload') }}</span>
        </div>
      </v-card-title>
      <div class="ma-5">
        <div v-if="isDisabling">
          <span class="modal-desc-text">{{ $t('amazon_transparency_existing_uploaded') }}</span><br/>
          <span>{{ $t('amazon_transparency_after_disabling') }}</span>
        </div>
        <div v-else>
          <span class="modal-desc-text">{{ $t('amazon_transparency_please_confirm') }}</span><br/>
          <span>{{ $t('amazon_transparency_enable_qr_upload') }}</span>
        </div>
      </div>
      <v-card-actions class="pa-4 px-8 mt-3 pb-6">
        <v-spacer></v-spacer>
        <v-btn color="primary" text class="text-uppercase" @click="handleCancelBtn">{{ $t('amazon_transparency_cancel') }}</v-btn>
        <v-btn v-if="isDisabling" color="red" text class="text-uppercase" @click="handleDisableBtn">
          {{ $t('amazon_transparency_disable') }}
        </v-btn>
        <v-btn v-else color="primary" text class="text-uppercase" @click="handleEnableBtn">
          {{ $t('amazon_transparency_enable') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AutoUploadConfirmationModal',
  props: {
    displayConfirmationModal: {
      type: Boolean,
      required: true
    },
    handleCancelBtn: {
      required: true,
      type: Function
    },
    handleDisableBtn: {
      required: true,
      type: Function
    },
    handleEnableBtn: {
      required: true,
      type: Function
    },
    isDisabling: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped lang="sass">
  .modal-desc-text
    color: #000 !important
    font-size: 16px !important
    font-style: normal !important
    font-weight: 400 !important
    line-height: 26px !important

</style>
